import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Provider } from './Context';
import { Checkbox, CheckboxIndicator, FieldError, File, Group, Hint, Input, Label, Radio, Textarea } from './components';
const FieldComponent = forwardRef(({ as: Element = 'div', className, id, children, ...rest }, ref) => {
    return (_jsx(Element, { ref: ref, className: className, children: _jsx(Provider, { id: id, ...rest, children: children }) }));
});
FieldComponent.displayName = 'Field';
const Field = FieldComponent;
Field.displayName = 'Field';
Field.Error = FieldError;
Field.File = File;
Field.Group = Group;
Field.Hint = Hint;
Field.Input = Input;
Field.Label = Label;
Field.Textarea = Textarea;
Field.Checkbox = Checkbox;
Field.CheckboxIndicator = CheckboxIndicator;
Field.Radio = Radio;
export { Field };
//# sourceMappingURL=Field.js.map